import React from 'react';

interface CalendarHeaderProps {
  onAddEventClick: () => void;
  onTemplatesClick: () => void;
}

const CalendarHeader: React.FC<CalendarHeaderProps> = ({ onAddEventClick, onTemplatesClick }) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <h1 className="text-2xl font-semibold text-gray-800">Scheduling</h1>
      <div className="space-x-2">
        <button
          onClick={onAddEventClick}
          className="px-4 py-2 bg-[#4A5568] text-white rounded-md hover:bg-[#2D3748] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2D3748]"
        >
          Add Event
        </button>
        <button
          onClick={onTemplatesClick}
          className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
        >
          Manage Templates
        </button>
      </div>
    </div>
  );
};

export default CalendarHeader; 